/* Click-to-chat only. A visitor must send the WhatsApp message to register. */
(() => {
  if (customElements.get('uku-whatsapp-signup')) return;
  customElements.define('uku-whatsapp-signup', class extends HTMLElement {
    connectedCallback() {
      this.listeners?.abort();
      this.listeners = new AbortController();
      const options = { signal: this.listeners.signal };
      const select = this.querySelector('[data-uku-wa-product]');
      const link = this.querySelector('[data-uku-wa-link]');
      const number = (this.dataset.businessNumber || '').replace(/[^0-9]/g, '');
      if (!select || !link || !/^[1-9]\d{7,14}$/.test(number)) return;
      const updateLink = () => {
        const message = 'Hi UKU, please add me to the next-batch waitlist. Product interest: ' + select.value + '. I agree to receive UKU next-batch availability, pricing and production updates on WhatsApp. I can reply STOP to opt out. I understand this is not an order or a reservation.';
        link.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
      };
      const setProduct = (value) => {
        if (Array.from(select.options).some((item) => item.value === value)) {
          select.value = value;
          updateLink();
        }
      };
      select.addEventListener('change', updateLink, options);
      document.addEventListener('change', (event) => {
        if (event.target instanceof HTMLSelectElement && event.target.matches('[data-product-interest]')) setProduct(event.target.value);
      }, options);
      document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const trigger = event.target.closest('[data-uku-interest]');
        if (trigger) setProduct(trigger.dataset.ukuInterest);
      }, options);
      updateLink();
    }
    disconnectedCallback() { this.listeners?.abort(); }
  });
})();
